import { render, staticRenderFns } from "./index-car-riding.vue?vue&type=template&id=e60de8a4&"
import script from "./index-car-riding.vue?vue&type=script&lang=js&"
export * from "./index-car-riding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports